import React, { useState } from "react";
import { createContext } from "react";
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

export const GeneralContext = createContext();

export function GeneralContextProvider(props) {
    const [user, setUser] = useState()
    const [ejes, setEjes] = useState()
    const [configuration, setConfiguration] = useState()
    const [idCuestionarioActual, setIdCuestionarioActual] = useState()
    const [cuestionarioID, setCuestionarioID] = useState()
    const [questionaryPercentage, setQuestionaryPercentage] = useState()
    const [idAxe, setIdAxe] = useState()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [chartImage, setChartImage] = useState();
    const [perfilEmpresarial, setPerfilEmpresarial] = useState();
    const [loadingModal, setLoadingModal] = React.useState(null);

  return (
        <GeneralContext.Provider
            value={{
                t,
                user,
                setUser,
                ejes,
                setEjes,
                configuration,
                setConfiguration,
                idCuestionarioActual,
                setIdCuestionarioActual,
                questionaryPercentage,
                setQuestionaryPercentage,
                cuestionarioID,
                setCuestionarioID,
                navigate,
                idAxe,
                setIdAxe,
                chartImage,
                setChartImage,
                perfilEmpresarial,
                setPerfilEmpresarial,
                //loadingModal,
                setLoadingModal
            }}
        >
            {props.children}
        </GeneralContext.Provider>
    );
}
